<template>
  <div class="faq-conainer">
    <div class="faq-header">FREQUENTLY ASKED QUESTIONS</div>
    <div class="section-container">
      <div class="faq-box" v-for="(faq, index) in faqList" :key="index">
        <div class="question">
          {{ faq.question }}
        </div>
        <div class="answer">
          {{ faq.answer }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      // isModalVisible: false
      faqList: [
        {
          question: `Why am I paying before I can even speak to the team?`,
          answer: `You pay to reserve the team and book them for a session that covers team evaluation, consultation and ideation.`,
        },
        {
          question: `How do you find these teams?`,
          answer: `Each product team on Grupa onboards as a team of professionals that have a work history together, from anywhere in the world.`,
        },
        {
          question: `What happens if I’m not satisfied after meeting the team?`,
          answer: `Each product team on Grupa onboards as a team of professionals that have a work history together, from anywhere in the world.`,
        },
        {
          question: `What’s the structure of the team?`,
          answer: `A product team consists of 5 - 7 professionals that includes a Product Designer, Software Engineers, a  Product Manager and a Quality Assurance Analyst.`,
        },
        {
          question: `How do you vet your teams?`,
          answer: `The teams are rigorously tested for individual coding skills, teamwork, code quality, product philosophy and reviews from previous clients before they are activated.`,
        },
        {
          question: `How long does it take to build the first iteration of my product?`,
          answer: `You can ship the minimal iteration of your product in (4weeks, 6 weeks or 8 weeks) depending on your service subscription plan.`,
        },
      ],
    };
  },
  mounted() {},
  computed: {},
  methods: {},
};
</script>
<style scoped>
* {
  font-family: Moderat;
  font-style: normal;
  font-weight: normal;
}
.faq-conainer {
  padding: 48px 7%;
}
.faq-header {
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: #979da5;
  text-align: initial;
}
.section-container {
  display: flex;
  margin-top: 48px;
  justify-content: space-between;
  flex-wrap: wrap;
}
.faq-box {
  width: 410px;
  text-align: initial;
  margin-bottom: 48px;
}
.question {
  font-weight: 500;
  font-size: 16px;
  line-height: 130%;
  color: #1b1e22;
}
.answer {
  margin-top: 8px;
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: #53585f;
}
</style>

